var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-container"},_vm._l((_vm.pageNum),function(cun){return _c('canvas',{key:cun,staticClass:"pdf-canvas",attrs:{"id":("the-canvas-" + cun)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }